import { CEIngestBase } from './ce-ingest-base'


export class CEIngest extends CEIngestBase {

}